export default "__VITE_ASSET__CIqRRej1__"